// CMS-7167. The individual e-mails an institution (group, unit, school, class) can switch on or off
// for its own students, behind its `email_settings` master switch. null means "inherit": the closest
// institution above that sets it, then the whitelabel or Settings.
//
// mail_progress_check is left out on purpose: it has no switch anywhere in the CMS.
const EMAIL_FLAGS = [
  { field: 'mailNotifyRemoveLicense', api: 'mail_notify_remove_license' },
  { field: 'mailNotifyActiveLicense', api: 'mail_notify_active_license' },
  { field: 'mailNotifyAddLicense', api: 'mail_notify_add_license' },
  { field: 'mailInvoiceReceipt', api: 'mail_invoice_receipt' },
  { field: 'mailSignUpByTeacher', api: 'mail_sign_up_by_teacher' },
  { field: 'mailSignUpMsg', api: 'mail_sign_up_msg' },
  { field: 'mailForgotPassword', api: 'mail_forgot_password' },
];

const EMAIL_FLAG_INHERIT = 'inherit';
const EMAIL_FLAG_ON = 'on';
const EMAIL_FLAG_OFF = 'off';

const emailFlagsFromApi = (institution = {}) =>
  EMAIL_FLAGS.reduce(
    (model, { field, api }) => ({
      ...model,
      [field]: institution[api] ?? null,
    }),
    {}
  );

// Always sent, null included: it is how an e-mail goes back to inheriting.
const emailFlagsToApi = (model = {}) =>
  EMAIL_FLAGS.reduce(
    (request, { field, api }) => ({ ...request, [api]: model[field] ?? null }),
    {}
  );

const emailFlagToOption = (value) => {
  if (value === true) return EMAIL_FLAG_ON;
  if (value === false) return EMAIL_FLAG_OFF;
  return EMAIL_FLAG_INHERIT;
};

const optionToEmailFlag = (option) => {
  if (option === EMAIL_FLAG_ON) return true;
  if (option === EMAIL_FLAG_OFF) return false;
  return null;
};

export {
  EMAIL_FLAGS,
  EMAIL_FLAG_INHERIT,
  EMAIL_FLAG_ON,
  EMAIL_FLAG_OFF,
  emailFlagsFromApi,
  emailFlagsToApi,
  emailFlagToOption,
  optionToEmailFlag,
};
